// ===============================================
// 🌐 БЭКЕНД API СЕРВИС (ФРОНТЕНД)
// ===============================================

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

class BackendApiService {
  constructor() {
    this.baseURL = BACKEND_URL;
    console.log('🌐 Backend API Service инициализирован:', this.baseURL);
  }

  // Общий метод для запросов к API
  async makeRequest(endpoint, options = {}) {
    const url = `${this.baseURL}${endpoint}`;
    
    const defaultOptions = {
      headers: {
        'Content-Type': 'application/json',
      },
      ...options
    };

    try {
      console.log(`📡 API запрос: ${options.method || 'GET'} ${url}`);
      
      const response = await fetch(url, defaultOptions);
      
      if (!response.ok) {
        const errorMessage = `HTTP error! status: ${response.status}`;
        console.error(`❌ ${errorMessage} для ${endpoint}`);
        throw new Error(errorMessage);
      }
      
      const data = await response.json();
      console.log(`✅ API ответ: ${endpoint}`, data);
      
      return data;
    } catch (error) {
      console.error(`❌ Ошибка API запроса ${endpoint}:`, error);
      throw error;
    }
  }

  // ===============================================
  // 🎮 STEAM API
  // ===============================================

  // Проверка Steam аккаунта
  async verifySteamAccount(account) {
    return this.makeRequest('/api/steam/verify-account', {
      method: 'POST',
      body: JSON.stringify({ account })
    });
  }

  // Создание платежа Steam
  async createSteamPayment(account, amount, currency = 'USD') {
    return this.makeRequest('/api/steam/create-payment', {
      method: 'POST',
      body: JSON.stringify({ account, amount, currency })
    });
  }

  // Пополнение Steam аккаунта
  async topupSteamAccount(account, amount, paymentId) {
    return this.makeRequest('/api/steam/topup-account', {
      method: 'POST',
      body: JSON.stringify({ account, amount, paymentId })
    });
  }

  // ===============================================
  // 💳 СБП API
  // ===============================================

  // Создание QR-кода СБП
  async createSBPQR(amount, steamAccount) {
    return this.makeRequest('/api/sbp/create-qr', {
      method: 'POST',
      body: JSON.stringify({ amount, steamAccount })
    });
  }

  // Создание криптоплатежа
  async createCryptoPayment(amountUSD, steamAccount) {
    return this.makeRequest('/api/sbp/create-crypto-payment', {
      method: 'POST',
      body: JSON.stringify({ amountUSD, steamAccount })
    });
  }

  async getCryptoCommission() {
    return this.makeRequest('/api/currency/crypto-commission', {
      method: 'GET'
    });
  }


  // Проверка статуса платежа СБП
  async checkSBPPaymentStatus(paymentGuid) {
    return this.makeRequest(`/api/sbp/payment-status/${paymentGuid}`, {
      method: 'GET'
    });
  }


  // ===============================================
  // 💱 КУРСЫ ВАЛЮТ API
  // ===============================================

  // Получение курсов валют
  async getCurrencyRates() {
    return this.makeRequest('/api/currency/rates', {
      method: 'GET'
    });
  }

  // Конвертация валют
  async convertCurrency(amount, fromCurrency, toCurrency) {
    return this.makeRequest('/api/currency/convert', {
      method: 'POST',
      body: JSON.stringify({ amount, fromCurrency, toCurrency })
    });
  }

  // Получение информации о валютах
  async getCurrencyInfo() {
    return this.makeRequest('/api/currency/info', {
      method: 'GET'
    });
  }

  // ===============================================
  // 🔗 WEBHOOK
  // ===============================================

  // Проверка статуса webhook
  async checkWebhookStatus() {
    return this.makeRequest('/webhook/sbp', {
      method: 'GET'
    });
  }

  // ===============================================
  // 📋 ЗАКАЗЫ
  // ===============================================

  // Создание заказа
  async createOrder(steamAccount, amountUSD, description) {
    return this.makeRequest('/api/orders/create', {
      method: 'POST',
      body: JSON.stringify({ steamAccount, amountUSD, description })
    });
  }

  // Получение статуса заказа
  async getOrderStatus(orderId) {
    return this.makeRequest(`/api/orders/status/${orderId}`, {
      method: 'GET'
    });
  }


  // ===============================================
  // 🏥 HEALTH CHECK
  // ===============================================

  // Проверка здоровья сервера
  async healthCheck() {
    return this.makeRequest('/health', {
      method: 'GET'
    });
  }
}

// Создаем единственный экземпляр сервиса
const backendApiService = new BackendApiService();

export default backendApiService;
